import { HTMLAttributes } from 'react';

interface ContentProps extends HTMLAttributes<HTMLDivElement> {
    withoutWrapper: boolean,
    children?: React.ReactNode,
}

function ContentTV({ withoutWrapper, ...props }: ContentProps) {
    const { children } = props;
    return (
        withoutWrapper ?
            <>
                {children}
            </>
            :
            <div className="tv-content">
                {children}
            </div>
    );
}

export default ContentTV;
